t = require('app/scripts/views/internal/teacup-with-helpers')('footer_chrome')

module.exports = t.renderable ({ url, shouldDisplayLogout }) ->
  t.a '.footer-chrome-logo', { href: '/', 'aria-label': t.l('trello-home') }
  t.div '.footer-chrome-links', ->
    t.a '.dark-hover', { href: url, target: '_blank', rel: 'noopener' }, ->
      t.format 'open-in-new-window'
      t.span '.icon-sm.icon-external-link'
    if shouldDisplayLogout()
      t.a '.dark-hover.js-logout.footer-logout', { href: '#' }, ->
        t.format 'log-out'
        t.span '.icon-sm.icon-log-out'
